import React, { Component } from 'react';
import {
    Form, Input, Button, Select, Modal, InputNumber,
} from 'antd';

import 'antd/dist/antd.css';

const Option = Select.Option;

function handleChange(value) {
  console.log(`selected ${value}`);
}

function handleBlur() {
  console.log('blur');
}

function handleFocus() {
  console.log('focus');
}

class MachineRepairsAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(e);
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
                this.props.form.resetFields();
            }
        });
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { repair } = this.props;
        return (
            <div>
                <Modal
                    title="Manejo de Reparación"
                    visible={this.props.openForm}
                    onOk={this.handleOk}
                    onCancel={this.props.onCancel}
                    footer={null}
                >
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item
                            {...formItemLayout}
                            label="Cost"
                        >
                            {getFieldDecorator('cost', {
                                initialValue: (repair != null) ? repair.cost : '',
                            })(
                                <InputNumber min={0} />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Status"
                        >
                            {getFieldDecorator('status', {
                                initialValue: (repair != null) ? repair.status : '',
                                rules: [{ required: true, message: 'Select a Status' }],
                            })(
                                <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Select a Status"
                                    optionFilterProp="children"
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value="Open">
                                        Open
                                    </Option>
                                    <Option value="Close">
                                        Close
                                    </Option>
                                </Select>,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Part Number"
                        >
                            {getFieldDecorator('part', {
                                initialValue: (repair != null) ? repair.part : '',
                            })(
                                <Input />,
                            )}
                        </Form.Item>
                        <Form.Item
                            {...formItemLayout}
                            label="Description"
                        >
                            {getFieldDecorator('details', {
                                initialValue: (repair != null) ? repair.details : '',
                                rules: [{ required: true, message: 'Insert Description' }],
                            })(
                                <Input.TextArea rows={4} />,
                            )}
                        </Form.Item>
                        
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" onClick={this.handleOk}>
                                Save
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(MachineRepairsAddView);



// WEBPACK FOOTER //
// ./src/components/views/MachineRepairsAddView.js